import { useEffect, useRef } from 'react';

/**
 * Crown UI's Dialog invokes its onClose prop from an internal effect whenever it first mounts (or
 * re-renders) with isOpen false - which is the normal starting state for the always-mounted,
 * toggle-visibility dialogs used across this app. That call fires before the host component's own
 * mount effects run, so guard against it by ignoring any onClose invocation that happens before this
 * component has finished mounting, letting genuine (post-mount) closes proceed as normal.
 */
export const useDialogCloseGuard = (onClose: () => void) => {
  const hasMountedRef = useRef(false);

  useEffect(() => {
    hasMountedRef.current = true;
  }, []);

  return () => {
    if (!hasMountedRef.current) {
      return;
    }
    onClose();
  };
};
